import { Box, Typography, IconButton } from "@mui/joy";
import { MoreHorizontal } from "lucide-react";
import ReactECharts from "echarts-for-react";
import { useDashboardData } from "../hooks";

export default function ProjectMonthly() {
    const { monthlyProjectStats } = useDashboardData();
    const { months, created, completed } = monthlyProjectStats;

    const option = {
        textStyle: { fontFamily: "Outfit, sans-serif" },
        tooltip: {
            trigger: "axis",
            axisPointer: { type: "shadow" },
        },
        legend: {
            top: 0,
            right: 0,
            itemWidth: 12,
            itemHeight: 12,
            itemGap: 20,
            textStyle: {
                fontSize: 12,
                color: "#64748b",
            },
        },
        grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            top: "40px",
            containLabel: true,
        },
        xAxis: {
            type: "category",
            data: months,
            axisTick: { show: false },
            axisLine: { show: false },
            axisLabel: {
                color: "#94a3b8",
                fontSize: 11,
                margin: 16,
            },
        },
        yAxis: {
            type: "value",
            minInterval: 2,
            splitLine: {
                lineStyle: {
                    type: "dashed",
                    color: "#e2e8f0",
                },
            },
            axisLabel: {
                color: "#94a3b8",
                fontSize: 11,
            },
        },
        series: [
            {
                name: "Created",
                type: "bar",
                data: created,
                barWidth: 14,
                barGap: "30%",
                itemStyle: {
                    color: "#c7d2e0",
                    borderRadius: [4, 4, 0, 0],
                },
            },
            {
                name: "Completed",
                type: "bar",
                data: completed,
                barWidth: 14,
                itemStyle: {
                    color: "#35b084",
                    borderRadius: [4, 4, 0, 0],
                },
            },
        ],
    };

    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, flex: 1 }}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Box mb={-6}>
                    <Typography level="title-lg">Project Activity</Typography>
                    <Typography level="body-md">Monthly creation vs completion</Typography>
                </Box>
                <IconButton>
                    <MoreHorizontal
                        size={20}
                        color="var(--standard-palette-neutral-500)"
                        style={{ cursor: "pointer" }}
                    />
                </IconButton>
            </Box>

            <Box sx={{ height: 280 }}>
                <ReactECharts option={option} style={{ height: "100%", width: "100%" }} opts={{ renderer: "svg" }} />
            </Box>
        </Box>
    );
}
